const isProduction = process.env.NODE_ENV === 'production';

const getDefaultApiUrl = () => (isProduction ? '' : 'http://127.0.0.1:8000');

const trimTrailingSlash = (value) => value.replace(/\/$/, '');

const getLocalPreviewApiUrl = () => {
  if (typeof window === 'undefined') return '';

  const { protocol, hostname } = window.location;
  if (!['localhost', '127.0.0.1'].includes(hostname)) {
    return '';
  }

  return `${protocol}//${hostname}:8000`;
};

const getApiUrl = () => {
  const configuredApiUrl = (process.env.REACT_APP_API_URL || '').trim();

  if (!isProduction) {
    return trimTrailingSlash(configuredApiUrl || getDefaultApiUrl());
  }

  if (configuredApiUrl.startsWith('http://') || configuredApiUrl.startsWith('https://')) {
    return trimTrailingSlash(configuredApiUrl);
  }

  if (configuredApiUrl.startsWith('/')) {
    return trimTrailingSlash(configuredApiUrl);
  }

  return getLocalPreviewApiUrl();
};

const API_URL = getApiUrl();

const getWebSocketOrigin = (
  apiUrl = API_URL,
  browserOrigin = typeof window === 'undefined' ? '' : window.location.origin,
) => {
  if (!apiUrl && !browserOrigin) return '';

  try {
    const backendUrl = new URL(apiUrl || '/', browserOrigin || undefined);
    if (!['http:', 'https:'].includes(backendUrl.protocol)) return '';
    backendUrl.protocol = backendUrl.protocol === 'https:' ? 'wss:' : 'ws:';
    return backendUrl.origin;
  } catch (_error) {
    return '';
  }
};

const WS_URL = getWebSocketOrigin();

export default API_URL;
export { getWebSocketOrigin, WS_URL };
